var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8418 7.12059C3.8418 6.59547 4.0504 6.09186 4.42173 5.72054C4.79305 5.34923 5.29667 5.14063 5.8218 5.14062H19.6818C20.2069 5.14063 20.7106 5.34923 21.0819 5.72054C21.4532 6.09186 21.6618 6.59547 21.6618 7.12059V17.0204C21.6618 17.5455 21.4532 18.0491 21.0819 18.4204C20.7106 18.7917 20.2069 19.0003 19.6818 19.0003H5.8218C5.29667 19.0003 4.79305 18.7917 4.42173 18.4204C4.0504 18.0491 3.8418 17.5455 3.8418 17.0204V7.12059Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8418 7.11719L12.7518 13.0571L21.6618 7.11719",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.76,
    height: 23.7595,
    fill: "white",
    transform: "translate(0.87207 0.191406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.eb11ef98a24882cb01ec7f5a3e29f0d1.svg";
export { ForwardRef as ReactComponent };